webpackJsonp([4],{

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(251);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43551fbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(294);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43551fbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43551fbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-not-found'
});

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(293);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("6a96c5eb", content, true, {});

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "div[data-v-43551fbc]{padding:0 1em;display:grid;grid-gap:2em;justify-items:center;-ms-flex-line-pack:center;align-content:center}a[data-v-43551fbc]{background-color:var(--primary-colour);color:#fff;font-weight:700;padding:1em 1.2em;border-radius:100px;display:grid;grid-gap:1em;grid-template-columns:auto auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a[data-v-43551fbc]:hover{background-color:var(--primary-colour-hover)}a:hover i[data-v-43551fbc]{color:rgba(0,0,0,.4)}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/PageNotFound.vue"],"names":[],"mappings":"AACA,qBACE,cAAe,AAEf,aAAc,AACd,aAAc,AACd,qBAAsB,AACtB,0BAA2B,AACvB,oBAAsB,CAC3B,AACD,mBACE,uCAAwC,AACxC,WAAa,AACb,gBAAkB,AAClB,kBAAmB,AACnB,oBAAqB,AACrB,aAAc,AACd,aAAc,AACd,gCAAiC,AACjC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,yBACE,4CAA8C,CAC/C,AACD,2BACE,oBAA0B,CAC3B","file":"PageNotFound.vue","sourcesContent":["\ndiv[data-v-43551fbc] {\n  padding: 0 1em;\n  \n  display: grid;\n  grid-gap: 2em;\n  justify-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\na[data-v-43551fbc] {\n  background-color: var(--primary-colour);\n  color: white;\n  font-weight: bold;\n  padding: 1em 1.2em;\n  border-radius: 100px;\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: auto auto;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\na[data-v-43551fbc]:hover {\n  background-color: var(--primary-colour-hover);\n}\na:hover i[data-v-43551fbc] {\n  color: rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Page not found")]),_vm._v(" "),_c('span',[_vm._v("Sorry, the page you're looking for doesn't exist.")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")]),_vm._v("\n  Go home\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.074770bf17fd1cb09265.js